import { isProjectVersionV3OrV4, isRevisionUpdatedAfterStartDate } from './shgcViewer';

export type CvViewerFeatures = {
  cvViewerAllowed?: boolean;
  cvViewerStartDate?: string | Date | null;
};

export const isCvViewerEnabled = (
  features: CvViewerFeatures | undefined,
  projectVersion: string | undefined,
  revisionUpdatedAt?: string | Date | null
): boolean =>
  !!(
    features?.cvViewerAllowed &&
    features?.cvViewerStartDate &&
    isProjectVersionV3OrV4(projectVersion) &&
    isRevisionUpdatedAfterStartDate(revisionUpdatedAt, features.cvViewerStartDate)
  );
